import { SuiteNumber } from "@ssc-booking/api-contracts"
import React, { ReactElement } from "react"
import { match } from "ts-pattern"
import GuaranteedSuiteInfo from "../../GuaranteedSuiteInfo/GuaranteedSuiteInfo"

export const cruiseLabel = (suiteName: string, selectedSuiteNumber?: SuiteNumber): ReactElement =>
    match(selectedSuiteNumber)
        .with(undefined, () => <React.Fragment>{suiteName}</React.Fragment>)
        .with(SuiteNumber.guaranteed, () => <GuaranteedSuiteInfo label={suiteName} />)
        .otherwise((x) => <React.Fragment>{`${suiteName} #${x}`}</React.Fragment>)
